export class CustomerOwnership {
    ID: number;
    Name: string;
}

export default CustomerOwnership;